<template>
  <div class="layout">
    <AppButton
      class="layout__skip-link"
      title="Ga naar hoofdinhoud"
      style="position: absolute; transform: translateY(-200%) scale(0.75)"
      @click="handleSkipLink"
    />
    <ClientOnly>
      <div id="fb-root" />
      <BreakpointListener />
    </ClientOnly>
    <LayoutsTopBar />
    <AppScrollProgressBar />
    <ClientOnly>
      <AppPageStatus :status="state.page?.status" />
    </ClientOnly>
    <main
      v-cloak
      id="main-content"
      aria-label="hoofdinhoud"
      tabindex="-1"
    >
      <slot />
    </main>
    <ClientOnly>
      <LayoutsUserBar
        v-if="state.page && state.auth"
        :id="state.page.id"
        :collection="state.page.collection"
      />
      <LayoutsShortOverlay />
    </ClientOnly>
    <LayoutsStoryOverlay />
  </div>
</template>

<script setup lang="ts">
import { type AuthenticationData } from '@directus/sdk'
import { reactive } from 'vue'
import BreakpointListener from '../components/components/BreakpointListener.client.vue'
import { usePageStore } from '~/store/page'
import { TPage } from '~/types/page-types'
import { useUserStore } from '~/store/user'

const pageStore = usePageStore()
const userStore = useUserStore()

type TState = {
  page?: TPage;
  showProgressBar: boolean
  auth?: AuthenticationData;
};

const state: TState = reactive({
  page: undefined,
  showProgressBar: false,
  auth: undefined
})

state.page = pageStore.getCurrentPage
state.auth = userStore.getAuth

pageStore.$subscribe(() => {
  state.page = pageStore.getCurrentPage
})

userStore.$subscribe(() => {
  state.auth = userStore.getAuth
})

function handleSkipLink () {
  const target = document.getElementById('main-content')
  if (target) {
    target.focus()
    target.scrollIntoView({ behavior: 'smooth' })
  }
}
</script>

<style scoped lang="postcss">
.layout {
  &__skip-link {
    /* this button has some inline styling to prevent content shift */
    position: absolute;
    top: 0;
    left: 0.5rem;
    z-index: 1000;
    transform-origin: top left;
    transition: transform 0.2s ease;
  }

  &__skip-link:focus {
    transform: translateY(0.5rem) scale(0.75) !important;
  }
}
</style>
